import script from "./PlayerSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerSearch.vue?vue&type=script&setup=true&lang=js"

import "./PlayerSearch.vue?vue&type=style&index=0&id=d3bc5090&lang=css"

const __exports__ = script;

export default __exports__